import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useGeneral } from '../Context/GeneralContext';

export default function LogOut() {
    const { logout } = useGeneral();
    const history = useHistory();

    useEffect(() => {
        history.replace('/');
        logout();
    }, [logout, history]);

    return null;
}
